module.exports = __webpack_public_path__ + "static/blog39-4ba2720a29b6ed4e5846ad7b9d3b1d76.png";